'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/comps/primitives/skeleton';
import { AiProficiencyReportCard } from '@/domains/pages/ai-proficiency/components/ai-proficiency-report-card';
import { UPSKILLING_LEVEL_GRID_ORDER } from '@/domains/pages/ai-proficiency/constants';
const HEXAGON_CLIP_PATH = 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)';
function RadarChartSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative h-48 w-48 shrink-0 pr-1"><div className="relative flex h-full w-full items-center justify-center"><div className="relative aspect-square w-[70%]">{[1, 0.75, 0.5, 0.25].map(_temp)}</div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(scale) {
  return <Skeleton key={scale} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-muted/30" style={{
    width: `${scale * 100}%`,
    height: `${scale * 100}%`,
    clipPath: HEXAGON_CLIP_PATH
  }} />;
}
function ScopeBarSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap items-center gap-3 border-b border-b-lightborder px-8 py-3"><Skeleton className="h-7 w-72 max-w-full rounded-md" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function LevelCardSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center border-b border-b-lightborder px-8 py-2"><Skeleton className="h-7 w-64 max-w-full rounded-md" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-6 px-8 py-2"><RadarChartSkeleton /><Skeleton className="h-4 w-40 max-w-full" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col">{t0}{t1}<div aria-hidden={true} className="px-8 pb-3"><div className="h-14" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function PromotionColumnSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col px-8 py-5"><Skeleton className="h-4 w-40" /><Skeleton className="mt-3 h-8 w-24" /><div aria-hidden={true} className="mt-4 h-3.5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function UpskillingChartsLoadingSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b border-b-lightborder px-8 py-3"><Skeleton className="h-3 w-72 max-w-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-4 items-start border-b border-b-lightborder"><div className="col-span-4"><AiProficiencyReportCard title="How to upskill each group" contentClassName="p-0"><div className="grid grid-cols-2 divide-x divide-y divide-lightborder">{UPSKILLING_LEVEL_GRID_ORDER.map(_temp2)}</div></AiProficiencyReportCard></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-b border-b-lightborder px-8 py-4"><Skeleton className="h-4 w-96 max-w-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t0}{t1}<div className="grid grid-cols-4 items-start"><div className="col-span-4"><AiProficiencyReportCard title="Promotion potential" contentClassName="p-0">{t2}<div className="grid grid-cols-2 divide-x divide-lightborder"><PromotionColumnSkeleton /><PromotionColumnSkeleton /></div></AiProficiencyReportCard></div></div></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(level) {
  return <LevelCardSkeleton key={level} />;
}
export function UpskillingPageLoadingSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b border-b-lightborder" data-testid="upskilling-page-loading"><ScopeBarSkeleton /><UpskillingChartsLoadingSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}